/**
 * Phase 4 Train 2 — the web half of NAMI_TREE_RECALL_V1: wikilink chips in
 * answers, the pill's label and links, the story's brain-read family. Read live
 * so tests can flip it.
 */
export function isBrainRecallEnabled(): boolean {
  return process.env.NEXT_PUBLIC_NAMI_TREE_RECALL_V1 === "true";
}
